import React from 'react';
import { useIdleTimer } from 'react-idle-timer';
import { useAuth } from '../../contexts/AuthContext';
import { useNavigate } from 'react-router-dom';

const IdleTimer = () => {
  const { logout, user } = useAuth();
  const navigate = useNavigate();

  const handleOnIdle = () => {
    if (user != null) {
      // console.debug('User is idle, logging out...');
      // Centralized logout will route admins to /admin/login and users to /login
      logout();
    }
  };

  const handleOnActive = () => {
    // console.debug('User is active');
  };

  const handleOnAction = () => {
    // console.debug('User performed an action');
  };

  const { getRemainingTime, getLastActiveTime } = useIdleTimer({
    // timeout: 20 * 1000, // 20 seconds for testing
   timeout: 1000 * 60 * 15, // 15 minutes
    onIdle: handleOnIdle,
    onActive: handleOnActive,
    onAction: handleOnAction,
    debounce: 500,
    crossTab: true, // Monitor activity across browser tabs
    startOnMount: true, // Start timer when component mounts
    startManually: false, // Don't require manual start
    events: [
      'mousemove',
      'keydown',
      'wheel',
      'DOMMouseScroll',
      'mousewheel',
      'mousedown',
      'touchstart',
      'touchmove',
      'MSPointerDown',
      'MSPointerMove',
      'visibilitychange'
    ]
  });

  // For debugging purposes
  React.useEffect(() => {
    const interval = setInterval(() => {
      // console.debug('Remaining time:', Math.ceil(getRemainingTime() / 1000), 'seconds');
      // console.debug('Last active:', new Date(getLastActiveTime()));
    }, 10000);

    return () => clearInterval(interval);
  }, [getRemainingTime, getLastActiveTime]);

  return null;
};

export default IdleTimer;